"use strict";

import * as React from 'react';

/**
 * Context which enables deprecated bubbling to child navigators.
 */
export const DeprecatedNavigationInChildContext = /*#__PURE__*/React.createContext(false);
//# sourceMappingURL=DeprecatedNavigationInChildContext.js.map